import "./redeem-reward-success.scss";

import { useUserIdentityContext } from "@core/services/user-identity.context";
import AnimatedCounter from "@core/ui/animated-counter/animated-counter";
import GridItem from "@core/ui/grid-item/grid-item";
import {
  GetResponseRewardModel,
  RewardBalance,
} from "@factory/model/query-model-reward";
import { viewAsset } from "@factory/query/google-cloud-storage.query";
import { useQyGetRewardBalance } from "@factory/query/reward.query";
import useScreenSize from "@shared/utility/screen-size";
import { isNil } from "lodash-es";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { appFeature } from "../../../app.feature";
import { useSphereRedeemItemCtx } from "../sphere-redeem-item/sphere-redeem-item.context";

export interface RedeemRewardSuccessProps {}

export function RedeemRewardSuccess() {
  // DECLARATIONS
  const { pointsText, stampsText } = appFeature.config.label;
  const { isMobileMode } = useScreenSize();
  const { selectedRedeemCampaign, cardAlias, setSelectedRedeemCampaign } =
    useSphereRedeemItemCtx();
  const navigate = useNavigate();
  const { getUserRole } = useUserIdentityContext();
  const { tenant } = getUserRole();
  const [, setAvatar] = useState<string>("");
  const [searchParam] = useSearchParams();
  const points = parseInt(searchParam.get("points") ?? "0", 10);
  const stamp = parseInt(searchParam.get("stamp") ?? "0", 10);
  const returnUrl = searchParam.get("return");

  // API DEFINITIONS
  const handleBalanceApiSuccess = async (response: GetResponseRewardModel) => {
    const data = response as RewardBalance;
    if (data?.level_avatar) {
      const assetFile = await viewAsset(data?.level_avatar);
      const blobFile = URL.createObjectURL(assetFile);
      setAvatar(blobFile);
    }
  };
  const { data: balance } = useQyGetRewardBalance(
    cardAlias ?? "",
    tenant,
    !!cardAlias,
    handleBalanceApiSuccess
  );
  const balanceData = balance as RewardBalance;

  // LOCAL FUNCTIONS

  // LOCAL RENDERS
  const footerContent = (
    <div>
      <Button
        className="block w-full mt-2"
        label="Close"
        severity="secondary"
        outlined
        onClick={() => {
          setSelectedRedeemCampaign(null);
          navigate(`/business/${returnUrl}`);
        }}
      />
    </div>
  );

  return (
    <div id="RedeemRewardSuccess" className="redeem-reward-success">
      <Dialog
        header="Successful Redeem"
        visible={true}
        style={{ width: "50vw" }}
        onHide={() => {
          navigate(-1);
        }}
        closeOnEscape={true}
        footer={footerContent}
        closable={false}
        maximized={isMobileMode}
      >
        <div className="m-0">
          {!isNil(balanceData) ? (
            <div className="text-center">
              <h3>Congratulations!</h3>
              <span className="text-green-500 text-4xl font-bold block">
                {balanceData?.first_name} {balanceData?.last_name}
              </span>
              <h5>You have redeemed an item</h5>

              {selectedRedeemCampaign ? (
                <div className="mb-12 mt-12">
                  <GridItem campaign={selectedRedeemCampaign} />
                </div>
              ) : null}
            </div>
          ) : null}

          <h4 className="text-center">You have redeemed</h4>
          <div className="flex justify-center gap-4 mt-6">
            {points ? (
              <AnimatedCounter
                from={0}
                to={points}
                duration={1}
                delay={1}
                label={pointsText}
              />
            ) : null}
            {points & stamp ? <Divider layout="vertical" /> : null}
            {stamp ? (
              <AnimatedCounter
                from={0}
                to={stamp}
                duration={1}
                delay={1}
                label={stampsText}
              />
            ) : null}
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default RedeemRewardSuccess;
